import * as React from "react";
import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import { useAppDispatch } from "app.hook";
import "./item-view-cart-mobile.less";
import { ShoppingCartItem } from "states/shopping-cart/shopping-cart.models";
import {
  calculateTotal,
  removeItemShoppingCart,
  updateQuantityItemShoppingCart,
} from "states/shopping-cart/shopping-cart.slice";
import {
  closeConfirmModal,
  showConfirmModal,
} from "states/global-value/global-value.slice";
import { ConfirmModel } from "states/global-value/global-value.models";
import { IconMinus, IconPlus } from "themes";
export interface IButtonModalViewCartProps {
  item: ShoppingCartItem;
  index: number;
}

export function ItemModalViewMobileCart({
  item,
  index,
}: IButtonModalViewCartProps) {
  const dispatch = useAppDispatch();
  const handleRemove = () => {
    dispatch(removeItemShoppingCart(index));
    dispatch(closeConfirmModal());
  };

  const handleUpdateQuantity = (quantity: number) => {
    dispatch(updateQuantityItemShoppingCart({ index, quantity }));
  };

  return (
    <div className="item-cart-mobile flex  justify-center mt-5">
      <div className="img-container img--container-center ">
        {item.image !== null ? (
          <img
            className="object-center"
            src={redirectFileLocalUrl(item.image)}
            alt=""
          />
        ) : (
          <div className="flex content-center items-center avatar-thumb h-full w-full bg-yellow-50"></div>
        )}
      </div>
      <div className="info flex-auto">
        <div className="name ">
          <span className="text-sm font-semibold uppercase">{item.name} | {formatMoney(item.price, 2, ".", ",", "$")}</span>
          <div className="modifiers text-xs">
            {item.modifiers.map((modi) => (
              <span>{modi.name} | {formatMoney(modi.price, 2, ".", ",", "$")}</span>
            ))}
          </div>
        </div>
        <div className="flex justify-between content-center items-center">
          <div className="text-red text-sm text-base">
            {formatMoney(calculateTotal(item), 2, ".", ",", "$")}
          </div>
          <div className="quantity-container flex place-content-center justify-between content-center items-center">
            <button
              onClick={() => {
                if (item.quantity - 1 === 0) {
                  dispatch(
                    showConfirmModal({
                      title: "Warning",
                      message: "Are you sure, you want to delete this?",
                      onYes: () => {
                        handleRemove();
                      },
                    } as ConfirmModel)
                  );
                  return -1;
                }

                handleUpdateQuantity(item.quantity - 1);
              }}
              className="btn--default outline-none border-none p-2"
            >
              <IconMinus width={20} />
            </button>
            <span className="text-md">{item.quantity}</span>
            <button
              onClick={() => {
                handleUpdateQuantity(item.quantity + 1);
              }}
              className="btn--default outline-none p-2"
            >
              <IconPlus width={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
